import React, { useEffect, useState } from 'react'
import { adminMenuRequest } from '../Types/AdminType';
import { getAllAdminMenus } from '../Services/AdminService';
import AdminDashboardMenuComponent, { AdminMenuItem } from '../Components/AdminDashboardMenuComponent';
import AdminHeaderComponent from '../Components/AdminHeaderComponent';


function CandidateConfigByAdminPage() {
const [adminMenu, setAdminMenu] = useState<adminMenuRequest []>([]);
const [loading, setLoading] = useState<boolean>(true);
const [error, setError] = useState<string>("");

useEffect(() => {
  const fetchCandidate = async () => {
   
    try {
      setLoading(true); // Ensure loading is true when starting
      const response = await getAllAdminMenus();

      console.log("Admin Menus API Response:", response); // Debug log

      if (response.success) {
        setAdminMenu(response.data);
      } else {
        setError(response.message || "Could not retrieve admin menus.");
      }
    } catch (err) {
      setError("An unexpected error occurred while loading the profile.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  fetchCandidate();
}, []); // Empty dependency array is fine if using localStorage
  return (
    <div>
      {/* <AdminHeaderComponent/> */}
        <AdminDashboardMenuComponent data={adminMenu as unknown as AdminMenuItem[]}/>

    </div>
  )
}

export default CandidateConfigByAdminPage